<script>
import Layout from "@/views/layouts/default";
import appConfig from "@/app.config";
import pdf from 'vue-pdf'

import { required } from "vuelidate/lib/validators";

export default {
  name: "Profile",
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    pdf
  },
  data() {
    return {
      form: {
        account_status: "",
        name: "",
        email: "",
        phone: "",
        address: "",
        industry_id: null,
        industry_name: "",
        province_id: null,
        city_id: null,
        zip_code: "",
        contact_person: "",
        yearly_income: "",
        registration_at: "",
        last_activity: "",
      },
      noLc: null,
      certifications: [],
      industryList: [],
      provinceList: [],
      cityList: [
        { value: null, text: 'Please select a province first' }
      ],
      documents: {
        deed_of_incorporation_path: null,
        siup_path: null,
        npwp_path: null,
        skdp_path: null,
        nib_path: null,
      },
      accountBank: {
        bank_name: "",
        account_number: "",
        account_name: "",
      },
      formAccountBank: {
        bank_name: "",
        account_number: "",
        account_name: ""
      },
      document: {
        type: "",
        src: ""
      },
      isSubmitError: false,
      errorMessage: null,
      isSubmitSuccess: false,
      successMessage: null,
    };
  },
  validations: {
    formAccountBank: {
      bank_name: { required },
      account_number: { required },
      account_name: { required },
    }
  },
  created() {
    this.getProfile()
    this.getAccountBank()
  },
  methods: {
    getProfile() {
      this.$axios.get('/v1/logistic_company/auth/profile')
        .then(response => {
          const lc = response.data.data.logistic_company
          this.form = {
            account_status: lc.account_status,
            name: lc.name,
            email: lc.email,
            phone: lc.phone,
            address: lc.address,
            industry_id: lc.industry_id.toString(),
            industry_name: lc.industry.name,
            province_id: lc.province_id.toString(),
            city_id: lc.city_id.toString(),
            zip_code: lc.zip_code,
            contact_person: lc.contact_person,
            yearly_income: lc.yearly_income,
            registration_at: lc.registration_at,
            last_activity: lc.last_activity,
          }
          this.noLc = lc.code
          if (lc.legal_documents) {
            const legal = lc.legal_documents
            this.documents = {
              deed_of_incorporation_path: legal.deed_of_incorporation_path,
              siup_path: legal.siup_path,
              npwp_path: legal.npwp_path,
              skdp_path: legal.skdp_path,
              nib_path: legal.nib_path,
            }
          }
          if (lc.certificates) {
            if (lc.certificates.alfa_ifa) this.certifications.push('ALFA/IFA')
            if (lc.certificates.iata) this.certifications.push('IATA')
            if (lc.certificates.fiata) this.certifications.push('FIATA')
            if (lc.certificates.dangerous_good) this.certifications.push('Barang Berbahaya')
            if (lc.certificates.other_detail) this.certifications.push(lc.certificates.other_detail)
          }
        })
    },
    getAccountBank() {
      this.$axios.get('/v1/logistic_company/bank_account')
        .then(response => {
          if (response.data.data.id !== undefined) {
            this.accountBank = {
              bank_name: response.data.data.bank_name,
              account_number: response.data.data.account_number,
              account_name: response.data.data.account_name
            }
            this.formAccountBank = {
              bank_name: response.data.data.bank_name,
              account_number: response.data.data.account_number,
              account_name: response.data.data.account_name
            }
          }
        })
    },
    submitAccountBank() {
      this.$v.$touch();
      if (!this.$v.formAccountBank.$invalid) {
        this.$refs.modalAccountBank.hide()
        this.$axios.post('/v1/logistic_company/bank_account', this.formAccountBank)
          .then(response => {
            this.isSubmitSuccess = true
            this.isSubmitError = false
            this.successMessage = response.data.message
            this.getAccountBank()
            this.$refs.modalAccountBank.hide()
          }).catch(error => {
            this.isSubmitSuccess = false
            this.isSubmitError = true
            this.errorMessage = error.response.data.message
          })
      }
    },
    previewDoc(doc) {
      const extention = doc.split(".").pop()
      this.document = {
        type: extention,
        src: doc
      }
      this.$refs.modalDocument.show()
    }
  }
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <div class="row align-items-center">
      <div class="col-sm-6">
        <div class="page-title-box">
          <h4 class="font-size-22">
            Lihat Profil
            <span v-if="noLc" class="badge badge-danger badge-pill ml-3">
              {{ noLc }}
            </span>
          </h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-model="isSubmitSuccess"
              class="mt-3"
              variant="success"
              dismissible
            >{{ successMessage }}</b-alert>

            <b-alert
              v-model="isSubmitError"
              class="mt-3"
              variant="danger"
              dismissible
            >{{errorMessage}}</b-alert>
            <div class="row mb-4">
              <div class="col-lg-6">
                <p class="font-weight-medium" :class="[ form.account_status == 'aktif' ? 'text-success' : 'text-danger']">
                  {{ form.account_status | capitalize }}
                </p>
                <h4>{{ form.name }}</h4>
                <p>{{ form.email }}</p>
                <p>CP: {{ form.contact_person }}</p>
              </div>
              <div class="col-lg-3 border-kiri pl-2">
                <p class="font-weight-medium">Alamat</p>
                <p>{{ form.address }}</p>
                <p class="font-weight-medium">Telepon</p>
                <p>{{ form.phone }}</p>
              </div>
              <div class="col-lg-3 border-kiri pl-4">
                <p class="font-weight-medium">Tanggal Register</p>
                <p>{{ form.registration_at | date_only }}</p>
                <p class="font-weight-medium">Aktifitas Terakhir</p>
                <p v-if="form.last_activity">{{ form.last_activity | date_time }}</p>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-lg-6">
                <h4>Bussines Profile</h4>
                <div class="d-flex">
                  <div class="mr-4">
                    <p class="font-weight-medium">Industri</p>
                    <p>{{ form.industry_name | capitalize }}</p>
                  </div>
                  <div class="mr-4">
                    <p class="font-weight-medium">Pendapatan / Tahun</p>
                    <p>IDR. {{ form.yearly_income | convertToRupiah }}</p>
                  </div>
                  <div class="ml-4">
                    <p class="font-weight-medium">Sertifikasi</p>
                    <p>{{ certifications.join(', ') }}</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 border-kiri pl-4" v-if="accountBank.bank_name !== ''">
                <p class="font-weight-medium">Akun Bank</p>
                <p>Bank {{ accountBank.bank_name }}</p>
                <p>Atas Nama {{ accountBank.account_name }}</p>
                <p>{{ accountBank.account_number }}</p>
              </div>
            </div>
            <h4>Dokumen Legalitas</h4>
            <div class="row mb-4">
              <div class="col-sm-2">
                <div class="border-radius text-center py-2">
                  <p class="font-weight-medium">Akta Pendirian Usaha</p>
                  <b-link v-if="documents.deed_of_incorporation_path" class="text-danger cursor-pointer" @click="previewDoc(documents.deed_of_incorporation_path)">
                    Lihat
                  </b-link>
                  <b-link v-else class="text-danger" target="_blank" href="#">
                    Belum Ada
                  </b-link>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="border-radius text-center py-2">
                  <p class="font-weight-medium">NPWP</p>
                  <b-link v-if="documents.npwp_path" class="text-danger cursor-pointer" @click="previewDoc(documents.npwp_path)">
                    Lihat
                  </b-link>
                  <b-link v-else class="text-danger" target="_blank" href="#">
                    Belum Ada
                  </b-link>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="border-radius text-center py-2">
                  <p class="font-weight-medium">SIUP / SIUJPT</p>
                  <b-link v-if="documents.siup_path" class="text-danger cursor-pointer" @click="previewDoc(documents.siup_path)">
                    Lihat
                  </b-link>
                  <b-link v-else class="text-danger" target="_blank" href="#">
                    Belum Ada
                  </b-link>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="border-radius text-center py-2">
                  <p class="font-weight-medium">SKDP</p>
                  <b-link v-if="documents.skdp_path" class="text-danger cursor-pointer" @click="previewDoc(documents.skdp_path)">
                    Lihat
                  </b-link>
                  <b-link v-else class="text-danger" target="_blank" href="#">
                    Belum Ada
                  </b-link>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="border-radius text-center py-2">
                  <p class="font-weight-medium">NIB</p>
                  <b-link v-if="documents.nib_path" class="text-danger cursor-pointer" @click="previewDoc(documents.nib_path)">
                    Lihat
                  </b-link>
                  <b-link v-else class="text-danger" target="_blank" href="#">
                    Belum Ada
                  </b-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2">
                <b-button to="/profile-update" type="button" variant="secondary" class="w-100">Ubah Profile</b-button>
              </div>
              <div class="col-sm-2">
                <b-button type="button" variant="danger" class="w-100" @click="$router.push('/job?tab=2')">Riwayat Job</b-button>
              </div>
              <div class="col-sm-2">
                <b-button type="button" variant="warning" class="w-100" @click="$refs.modalAccountBank.show()">Ubah Akun Bank</b-button>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <!-- modal akun bank -->
    <b-modal title="Akun Bank" ref="modalAccountBank" id="modal-account-bank" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-form @submit.prevent="submitAccountBank">
        <b-form-group id="bank-group" label="Bank" label-for="bank">
          <b-form-input
            id="bank"
            name="bank"
            v-model.trim="formAccountBank.bank_name"
            type="text"
            :class="{ 'is-invalid': $v.formAccountBank.bank_name.$error }"
          ></b-form-input>
          <div v-if="$v.formAccountBank.bank_name.$error" class="invalid-feedback">
            <span v-if="!$v.formAccountBank.bank_name.required">{{ $t('form.validation.required', { field: 'Bank' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="account-name-group" label="Atas Nama" label-for="account-name">
          <b-form-input
            id="account-name"
            name="account_name"
            v-model.trim="formAccountBank.account_name"
            type="text"
            :class="{ 'is-invalid': $v.formAccountBank.account_name.$error }"
          ></b-form-input>
          <div v-if="$v.formAccountBank.account_name.$error" class="invalid-feedback">
            <span v-if="!$v.formAccountBank.account_name.required">{{ $t('form.validation.required', { field: 'Atas Nama' }) }}</span>
          </div>
        </b-form-group>
        <b-form-group id="account-number-group" label="Nomor Rekening" label-for="account-number">
          <b-form-input
            id="account-number"
            name="account_number"
            v-model.trim="formAccountBank.account_number"
            type="text"
            :class="{ 'is-invalid': $v.formAccountBank.account_number.$error }"
          ></b-form-input>
          <div v-if="$v.formAccountBank.account_number.$error" class="invalid-feedback">
            <span v-if="!$v.formAccountBank.account_number.required">{{ $t('form.validation.required', { field: 'Nomor Rekening' }) }}</span>
          </div>
        </b-form-group>
        <b-button type="submit" variant="success">Simpan</b-button>
        <b-button type="button" variant="secondary" class="ml-2" @click="$refs.modalAccountBank.hide()">Batal</b-button>
      </b-form>
    </b-modal>
    <!-- /.modal -->

    <!-- modal preview document -->
    <b-modal title="Preview" ref="modalDocument" id="modal-document" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-12 text-center">
          <b-link :href="document.src" target="_blank">
            <pdf v-if="document.type === 'pdf'" :src="document.src"></pdf>
            <b-img v-else fluid :src="document.src"></b-img>
          </b-link>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </Layout>
</template>

<style scoped>
.icon-panah {
  position: absolute;
  top: 35%;
  left: 0%;
}
.content-slider {
  position: relative;
}
.nav-kiri {
  cursor: pointer;
  position: absolute;
  top: 45%;
  left: 5%;
}
.nav-kanan {
  cursor: pointer;
  position: absolute;
  top: 45%;
  right: 5%;
}

.total-job {
  position: absolute;
  top: 25%;
  right: 50%;
}

p {
  margin-bottom: 0px;
}
</style>